import type {
  DeliveryChargeRuleListResponseType,
  PriceTierDiscountListResponseType,
  ProductListResponseType,
} from "@sellar-io/api-v2/types";

import {
  calculateItemTotal,
  comparisonFor,
  CountryType,
} from "@sellar-io/common";

import { useContext } from "react";

import { OrderOnBehalfOfContext } from "../../../contexts/OrderOnBehalfOfContext";

export type OrderOnBehalfOfOrderItemType = {
  quantity: number;
  price: number;
  fullPrice: number;
  Product: ProductListResponseType[number];
  discountable: boolean;
};

export interface OrderDiscountType extends Omit<
  PriceTierDiscountListResponseType[number],
  "id" | "PriceTierId" | "type"
> {
  type: "percentage" | "perpetual-flat";
}

export type CustomDiscountType = {
  type: "percentage" | "flat";
  amount: number;
};

export type DeliveryAddressType = {
  name: string;
  street: string;
  city: string;
  region: string;
  postalCode: string;
  country: CountryType;
};

export const asOrderItemDeliveryDetails = (
  orderItem: OrderOnBehalfOfOrderItemType,
) => ({
  volume: orderItem.Product.volume,
  packQuantity: orderItem.Product.packQuantity,
  displayUnit: orderItem.Product.unit ?? "",
  containerType: orderItem.Product.containerType ?? "",
  quantity: orderItem.quantity,
  price: orderItem.price,
});

export const useOrderOnBehalfOfContext = () => {
  const context = useContext(OrderOnBehalfOfContext);
  if (context === undefined) {
    throw new Error(
      "useOrderOnBehalfOfContext must be within OrderOnBehalfOfContextProvider",
    );
  }

  return context;
};

export const doesOrderQualifyForDeliveryChargeRule = (
  deliveryChargeRule: Pick<
    DeliveryChargeRuleListResponseType[number],
    "comparator" | "value"
  >,
  orderItems: { price: number; quantity: number }[],
) => {
  return comparisonFor(
    deliveryChargeRule.comparator,
    calculateItemTotal(orderItems),
    deliveryChargeRule.value,
  );
};
